var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"address",style:({marginBottom: _vm.mb})},[_c('img',{attrs:{"src":require("@/assets/images/icons/map-pin.svg"),"alt":""}}),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }